import { Fragment } from "react";
import Hero from "container/datacenter/Hero";
import Service from "container/datacenter/Service";
import Locations from "container/home/Locations";
import Testimonial from "container/home/Testimonial";
import PageLayouts from "layouts/PageLayouts";
import BuyProxies from "container/home/BuyProxies";

const DataCenter = () => {
    return (
        <Fragment>
            <PageLayouts title="Datacenters">
                <Hero />
                <Service />
                <Locations classNames="desktop:!py-[96px]" />
                <Testimonial />
                <BuyProxies />
            </PageLayouts>
        </Fragment>
    );
};

export default DataCenter;